import * as React from "react";
import { WarningIcon } from "affinityIcons";
import { styled } from "styled-components";

import { Tag } from "affinityUI/elements/tag";

const RedAlertIcon = styled(WarningIcon)`
  color: ${({ theme }) => theme.colours.red[700]};
`;

export const ConfirmatoryTestInfoTag: React.FC<{ confirmatoryThreshold: string | number }> = ({
  confirmatoryThreshold,
}) => (
  <Tag data-testid="confirmatory-test-tag">
    <RedAlertIcon />
    {` `}
    Patients with neutrophils below {confirmatoryThreshold} may need a confirmatory blood test
  </Tag>
);
